module.exports = __webpack_public_path__ + "img/41_26.f0ba6dc9.png";